import { useQuery } from "@apollo/client";
import { useProcessIdOnSingleProcessPage } from "components/CustomGridItems/LotInfoBar/lotInfoUtils";
import { atom, useAtom } from "jotai";
import {
  SINGLE_SENSE_CONFIG_QUERY,
  midgardClients,
} from "providers/MidgardProvider";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { ONE_SECOND_OF_MS } from "utils/timeUtils";

/** fetches senseConfig.process.playbook and stores in useCurrentPlaybook */
export function CurrentPlaybookGetter() {
  useGetProcessPlaybook();
  return null;
}

const useGetProcessPlaybook = (): void => {
  const [, setCurrentPlaybook] = useProcessPlaybook();
  const processId = useProcessIdOnSingleProcessPage();
  const cKey = useCustomerKey();

  const { loading, refetch, error } = useQuery(SINGLE_SENSE_CONFIG_QUERY, {
    client: midgardClients.get(cKey),
    variables: {
      machemetryId: processId,
    },
    onError: err => {
      // refetch after a 10 second delay
      setTimeout(refetch, 10 * ONE_SECOND_OF_MS);
      console.log(`Sku list query gone wrong. cKey: ${cKey}`);
      console.log(`${err}: retrying in 10 seconds`);
    },
    onCompleted: data => {
      if (data?.senseConfig && !loading && !error) {
        const playbook = data.senseConfig?.process?.playbook;
        setCurrentPlaybook(playbook);
      }
    },
  });
};
type SkuPlaybook = {
  skuCode: string;
  plays: Play[];
};
type Play = {
  teamSize: number;
  targetProducingRate: {
    count: number;
    intervalMs: number;
  };
};
const playbookAtom = atom<SkuPlaybook[] | null>(null);
/** process's playbook from senseConfig.process.playbook */
export function useProcessPlaybook() {
  return useAtom(playbookAtom);
}
